"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _table = require("./table.proptypes");

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var MainWrapper = _styledComponents.default.table.withConfig({
  displayName: "Table__MainWrapper",
  componentId: "sc-1kbzrgp-0"
})(["width:100%;border-collapse:collapse;"]);

var TableBody = _styledComponents.default.tbody.withConfig({
  displayName: "Table__TableBody",
  componentId: "sc-1kbzrgp-1"
})([""]);

var TableHead = _styledComponents.default.thead.withConfig({
  displayName: "Table__TableHead",
  componentId: "sc-1kbzrgp-2"
})([""]);

var HeaderWrapper = _styledComponents.default.th.withConfig({
  displayName: "Table__HeaderWrapper",
  componentId: "sc-1kbzrgp-3"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";background-color:", ";padding:", ";text-align:", ";"], function (_ref) {
  var theme = _ref.theme,
      family = _ref.family;
  return theme.fontFamily[family];
}, function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return theme.fontSize[size];
}, function (_ref3) {
  var theme = _ref3.theme,
      weight = _ref3.weight;
  return theme.fontWeight[weight];
}, function (_ref4) {
  var theme = _ref4.theme,
      height = _ref4.height;
  return theme.lineHeight[height];
}, function (_ref5) {
  var theme = _ref5.theme,
      color = _ref5.color;
  return theme.colors[color];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.backgroundColor.greyLighter;
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.space.XSmall, " ").concat(theme.space.standard);
}, function (_ref8) {
  var alignment = _ref8.alignment;
  return alignment;
});

var RowWrapper = _styledComponents.default.tr.withConfig({
  displayName: "Table__RowWrapper",
  componentId: "sc-1kbzrgp-4"
})(["border-bottom:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return "1px solid ".concat(theme.colors.greyLight);
});

var ContentWrapper = _styledComponents.default.td.withConfig({
  displayName: "Table__ContentWrapper",
  componentId: "sc-1kbzrgp-5"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";background-color:", ";padding:", ";text-align:", ";span{font-size:", ";font-weight:", ";color:", ";}"], function (_ref10) {
  var theme = _ref10.theme,
      family = _ref10.family;
  return theme.fontFamily[family];
}, function (_ref11) {
  var theme = _ref11.theme,
      size = _ref11.size;
  return theme.fontSize[size];
}, function (_ref12) {
  var theme = _ref12.theme,
      weight = _ref12.weight;
  return theme.fontWeight[weight];
}, function (_ref13) {
  var theme = _ref13.theme,
      height = _ref13.height;
  return theme.lineHeight[height];
}, function (_ref14) {
  var theme = _ref14.theme,
      color = _ref14.color;
  return theme.colors[color];
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.backgroundColor.default;
}, function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.space.XSmall, " ").concat(theme.space.standard);
}, function (_ref17) {
  var alignment = _ref17.alignment;
  return alignment;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontSize.XSmall;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeight.normal;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.greyDark;
});

var Table = function Table(props) {
  var theme = props.theme,
      translation = props.translation,
      accessible = props.accessible,
      customProperties = props.customProperties,
      columns = props.columns,
      data = props.data;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var getHeader = function getHeader() {
    var headers = columns || [];
    return /*#__PURE__*/_react.default.createElement(RowWrapper, null, headers.map(function (_ref21, idx) {
      var columnKey = _ref21.columnKey,
          columnName = _ref21.columnName;
      var isLastColumn = idx === headers.length - 1;
      var textType = _constant.TEXT_TYPE.title;
      return /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
        key: columnKey,
        family: textType.fontFamily,
        size: textType.fontSize,
        weight: textType.fontWeight,
        height: textType.lineHeight,
        color: textType.fontColor,
        alignment: isLastColumn ? _constant.ALIGNMENT.right : _constant.ALIGNMENT.left
      }, language[columnKey] || columnName);
    }));
  };

  var getRows = function getRows() {
    return data.map(function (row) {
      var keys = Object.keys(row);
      return /*#__PURE__*/_react.default.createElement(RowWrapper, null, keys.map(function (key, idx) {
        var textType = key === _constant.COLUMNS.bookingNumber ? _constant.TEXT_TYPE.bookingTitle : _constant.TEXT_TYPE.text;
        var isLastColumn = idx === columns.length - 1;
        var value = (0, _typeof2.default)(row[key]) === 'object' && row[key].value ? row[key].value : row[key] || '';
        var children = (0, _typeof2.default)(row[key]) === 'object' && row[key].children ? row[key].children : '';
        var position = (0, _typeof2.default)(row[key]) === 'object' && row[key].childrenPosition ? row[key].childrenPosition : '';
        return /*#__PURE__*/_react.default.createElement(ContentWrapper, {
          family: textType.fontFamily,
          size: textType.fontSize,
          weight: textType.fontWeight,
          height: textType.lineHeight,
          color: textType.fontColor,
          alignment: isLastColumn ? _constant.ALIGNMENT.right : _constant.ALIGNMENT.left
        }, position === _constant.SUBTITLE_POSITION.prefix && children, language[value] || value, position === _constant.SUBTITLE_POSITION.postfix && children);
      }));
    });
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(MainWrapper, (0, _extends2.default)({
      tabIndex: tabIndex
    }, customProperties), /*#__PURE__*/_react.default.createElement(TableHead, null, getHeader()), /*#__PURE__*/_react.default.createElement(TableBody, null, getRows()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Table.propTypes = _table.TableProptypes.PropTypes;
Table.defaultProps = _table.TableProptypes.DefaultProps;
var _default = Table;
exports.default = _default;